module.exports = __webpack_public_path__ + "img/4-Frontline-Live-Chat-Page-MVP.659aa18e.png";